<template>
  <div>
    <v-row>
      <v-col cols="12">
        <buy-chart :summary="false" report_type="buy"></buy-chart>
      </v-col>
    </v-row>
  </div>
</template>
<script>


import BuyChart from "@/views/reports/BuyChart";
export default {
  name: "BuyChartReport",
  components: {
    BuyChart
  },
  props: {
    id: {},
  },
  data() {
    return {
    }
  },
}
</script>

<style scoped lang="scss"></style>

